import { LinkItem } from '@occc-app/design-system';

import { routeCreator as scanDataRouteCreator } from '../../scan-data.router';

export const breadcrumbs: LinkItem[] = [
  {
    label: 'Tobacco Offers',
    to: scanDataRouteCreator.base(),
  },
];
